import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ExotelVoiceWidget, { WEBSITE_AGENT_ID } from "../../components/VoiceAgent/ExotelVoiceWidget";
import "./SharedAgent.css";

const SharedAgent = () => {
  const { agentId } = useParams();
  const [voiceAgentId, setVoiceAgentId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // -------------------------------------------------------------
    // TODO: Replace this mock implementation with an actual API call
    // to your backend to get the voice agent ID using the `agentId`.
    // Example:
    // fetch(`https://api.yourcompany.com/agents/${agentId}`)
    //   .then(res => res.json())
    //   .then(data => setVoiceAgentId(data.agentId))
    // -------------------------------------------------------------
    
    // MOCK API CALL
    const fetchAgentData = async () => {
      try {
        setLoading(true);
        // Simulate network delay
        await new Promise(resolve => setTimeout(resolve, 800));
        
        // Mock response
        if (agentId) {
          // Chauwk Website Agent on the Exotel voice server
          setVoiceAgentId(WEBSITE_AGENT_ID);
        } else {
          throw new Error("Agent ID not found in URL");
        }
      } catch (err) {
        setError("Failed to load agent. Please check the link.");
      } finally {
        setLoading(false);
      }
    };

    fetchAgentData();
  }, [agentId]);

  if (loading) {
    return (
      <div className="shared-agent-container loading">
        <div className="spinner"></div>
        <p>Loading Agent...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="shared-agent-container error">
        <h2>Oops!</h2>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="shared-agent-container">
      <div className="shared-agent-content">
        <h1>Your AI Agent is Ready</h1>
        <p>Click the agent widget to start chatting or speaking.</p>
        
        {/* Exotel voice server widget, opened automatically */}
        {voiceAgentId && <ExotelVoiceWidget agentId={voiceAgentId} autoOpen />}
      </div>
    </div>
  );
};

export default SharedAgent;
